<template>
  <div>
    <slot
      :fieldValue="fieldValue"
      :fieldMutator="fieldMutator"
      :dynamicFieldValue="dynamicFieldValue"
    />
  </div>
</template>

<script>
export default {
  fieldName: 'Translatable',

  props: {
    language: {
      required: false,
      type: Object,
      default: null
    },
    fieldName: {
      required: true,
      type: String
    },
    value: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      fieldValue: '',
      dynamicFieldValue: ''
    }
  },

  watch: {
    language: function () {
      this.initFields()
    }
  },

  mounted () {
    this.initFields()
  },

  methods: {
    initFields () {
      const fieldValue = this.getFieldValue()
      this.fieldValue = fieldValue
      this.dynamicFieldValue = fieldValue
    },

    getFieldValue () {
      if (this.language && !this.language.default) {
        if (!this.value.translations || !this.value.translations[this.language.code]) {
          return ''
        }

        return this.value.translations[this.language.code][this.fieldName] || ''
      }

      return this.value[this.fieldName] || ''
    },

    fieldMutator (value) {
      this.dynamicFieldValue = value

      const object = this.value
      if (this.language && !this.language.default) {
        this.languageInit(object)
        object.translations[this.language.code][this.fieldName] = value
        this.$emit('input', object)
        return
      }

      object[this.fieldName] = value
      this.$emit('input', object)
    },

    languageInit (object) {
      if (!object.translations) {
        object.translations = {}
      }

      if (!object.translations.hasOwnProperty(this.language.code)) {
        object.translations[this.language.code] = {}
      }
    }
  }
}
</script>
